import * as env from './environment.uk';

let env_prod = {...env.environment};
env_prod['production'] = true;

export const environment = env_prod;



// WEBPACK FOOTER //
// /Users/matthijs/projects/PHILIPS/philips-dental-pro/shop/src/environments/environment.ts